import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { red } from '@material-ui/core/colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
    },
    initialComments: {
      width: '100%',
      marginBottom: theme.spacing(2),
    },
    metadata: {
      width: '50%',
      marginTop: theme.spacing(3),
    },
    reviewingPhysicianContainer: {
      width: '25%',
      marginTop: theme.spacing(3),
      textAlign: 'right',
    },
    reviewingPhysician: {
      width: 'auto !important',
    },
    normality: {
      marginTop: theme.spacing(2),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 220,
    },
    red: {
      color: red.A700,
    },
    abnormal: {
      color: red.A400,
    },
    critical: {
      color: red.A700,
    },
    closingComment: {
      width: '50% !important',
      marginTop: theme.spacing(2) + 'px !important',
      marginBottom: theme.spacing(4) + 'px !important',
    },
    closingContainer: {
      float: 'right',
    },
    contactContainer: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    buttonsContainer: {
      marginBottom: theme.spacing(16),
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    error: {
      color: red.A400,
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      tableLayout: 'auto',
    },
    header: {
      backgroundColor: theme.palette.grey[100],
      fontWeight: 'bold',
      textAlign: 'left',
      padding: theme.spacing(1),
    },
    dropdown: {
      width: '100%',
      padding: theme.spacing(0.5),
    },
    input: {
      width: '100%',
      border: 'none',
      padding: theme.spacing(0.5),
      backgroundColor: 'transparent',
      '&:focus': {
        outline: 'none',
      },
    },
    cell: {
      padding: theme.spacing(1),
      border: '1px solid #ccc',
    },
    tableCell: {
      padding: '8px',
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
      borderRight: `1px solid ${theme.palette.grey[300]}`,
    },
    lastTableCell: {
      padding: '8px',
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
    },
    saveButton: {
      padding: '10px 20px',
      borderRadius: '6px',
      marginLeft: '10px',
      cursor: 'pointer',
      '&:disabled': {
        backgroundColor: 'lightgray',
        color: 'black',
        cursor: 'not-allowed',
        opacity: 0.6,
      },
      '&:hover': {
        color: 'white',
        backgroundColor: 'green',
        opacity: 0.6,
      },
    },
    submitButton: {
      padding: '10px 20px',
      borderRadius: '5px',
      cursor: 'pointer',
      marginLeft: '10px',
      '&:disabled': {
        backgroundColor: 'lightgray',
        color: 'black',
        cursor: 'not-allowed',
        opacity: 0.6,
      },
      '&:hover': {
        color: 'white',
        backgroundColor: `${theme.palette.primary.main}`,
        opacity: 0.6,
      },
    },
    completeButton: {
      padding: '10px 20px',
      borderRadius: '5px',
      cursor: 'pointer',
      marginLeft: '10px',
      '&:disabled': {
        backgroundColor: 'lightgray',
        color: 'black',
        cursor: 'not-allowed',
        opacity: 0.6,
      },
      '&:hover': {
        backgroundColor: 'purple',
        color: 'white',
        opacity: 0.6,
      },
    },
    rejectButton: {
      padding: '10px 20px',
      borderRadius: '5px',
      cursor: 'pointer',
      marginLeft: '10px',
      '&:disabled': {
        backgroundColor: 'lightgray',
        color: 'black',
        cursor: 'not-allowed',
        opacity: 0.6,
      },
      '&:hover': {
        backgroundColor: 'red',
        color: 'white',
        opacity: 0.6,
      },
    },
    backButton: {
      padding: '10px 20px',
      borderRadius: '5px',
      cursor: 'pointer',
      marginLeft: '10px',
      '&:disabled': {
        backgroundColor: 'lightgray',
        color: 'black',
        cursor: 'not-allowed',
        opacity: 0.6,
      },
      '&:hover': {
        color: 'white',
        backgroundColor: `${theme.palette.primary.main}`,
        opacity: 0.6,
      },
    },
    tableHeader: {
      tableLayout: 'fixed',
      width: '100%',
      marginBottom: '5px',
    },
    headerCell: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      paddingLeft: '15px',
    },
    headerData: {
      padding: '16px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
      borderRadius: '4px',
    },
    pdfButton: {
      padding: '8px 35px',
      background: theme.palette.primary.main,
      color: '#fff',
      borderRadius: '4px',
      cursor: 'pointer',
      '&:hover': {
        background: theme.palette.primary.dark,
      },
    },
    dialogContainer: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    rejectDialogSelect: {
      'max-width': '300px',
      marginBottom: '20px',
    },
    rejectDialogTextBox: {
      'min-width': '450px',
    },
    cancelButton: {
      padding: '10px 20px',
      borderRadius: '5px',
      cursor: 'pointer',
      marginLeft: '10px',
      '&:hover': {
        background: theme.palette.primary.main,
        color: 'black',
        opacity: 0.6,
      },
    },
    requiredErrorText: {
      color: 'red',
    },
  })
);

export default useStyles;
